import { ActionButton, Entidade } from '@elotech/components';
import { alert } from 'common/components';
import { useMemo } from 'react';

import { ArquivoService } from '../../service';
import { ArquivoEntity } from '../../type';
import { FileType, TipoSigapEnum, tipoSigapEnum } from '../../type/enum';

type Props = {
  baseUrl: string;
  resource: string;
  file: ArquivoEntity;
  setLoading: (promise: Promise<any>) => Promise<any>;
  options: Record<string, string>;
  entidadeLogada: Entidade;
};

const fileTypesByEnum: Partial<Record<keyof typeof TipoSigapEnum, string[]>> = {
  PLANILHA_OBRA_LICITACAO: [FileType.XLS.toString(), FileType.XLSX.toString()],
  PLANILHA_OBRA_VENCEDOR: [FileType.XLS.toString(), FileType.XLSX.toString()],
  PLANILHA_ACOMPANHAMENTO: [FileType.XLS.toString(), FileType.XLSX.toString()],
  PROJETO_CONTRATADA: [FileType.PDF.toString()],
  PROJETO_CONTRATANTE: [FileType.PDF.toString()]
};

const simplifiedFileTypesNames = {
  [FileType.XLS.toString()]: 'XLS',
  [FileType.XLSX.toString()]: 'XLSX',
  [FileType.PDF.toString()]: 'PDF'
};

const TipoSigapArquivoComponent = ({
  file,
  baseUrl,
  resource,
  setLoading,
  options,
  entidadeLogada
}: Props) => {
  const service = useMemo(
    () => new ArquivoService(baseUrl, resource),
    [baseUrl, resource]
  );

  const isInformaSigap = useMemo(() => {
    return (
      entidadeLogada?.uf === 'RO' &&
      file?.arquivo?.mimeType &&
      [
        FileType.DOC.toString(),
        FileType.DOCX.toString(),
        FileType.JPG.toString(),
        FileType.JPEG.toString(),
        FileType.ODS.toString(),
        FileType.ODT.toString(),
        FileType.PDF.toString(),
        FileType.PNG.toString(),
        FileType.PPT.toString(),
        FileType.PPTX.toString(),
        FileType.RTF.toString(),
        FileType.TXT.toString(),
        FileType.XLS.toString(),
        FileType.XLSX.toString(),
        FileType.XML.toString(),
        FileType.ZIP.toString()
      ].includes(file?.arquivo?.mimeType)
    );
  }, [file, entidadeLogada]);

  const onConfirm = (value: TipoSigapEnum) => {
    const allowedFileTypes = fileTypesByEnum[value];

    if (
      allowedFileTypes &&
      !allowedFileTypes.includes(file?.arquivo?.mimeType!)
    ) {
      const simplifiedAllowedTypes = allowedFileTypes.map(
        type => simplifiedFileTypesNames[type] || type
      );

      return alert({
        type: 'error',
        text: `O tipo de arquivo selecionado não é permitido para o SIGAP ${
          tipoSigapEnum[value]
        }. Tipos permitidos: ${simplifiedAllowedTypes.join(', ')}.`
      });
    }

    return setLoading(service.changeTipoSigap(file.id!, value));
  };

  return (
    <>
      {isInformaSigap && (
        <ActionButton
          icon="money-bill-alt"
          label="Informe o SIGAP"
          onClick={() =>
            alert({
              type: 'question',
              text: 'SIGAP',
              input: 'select',
              inputOptions: options,
              cancelButtonText: 'Cancelar',
              confirmButtonText: 'Confirmar',
              onConfirm: value => onConfirm(value as TipoSigapEnum)
            })
          }
        />
      )}
    </>
  );
};

export default TipoSigapArquivoComponent;
